import { render, staticRenderFns } from "./ReviewPractice.vue?vue&type=template&id=7b2d0fe6&scoped=true&"
import script from "./ReviewPractice.vue?vue&type=script&lang=js&"
export * from "./ReviewPractice.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPractice.vue?vue&type=style&index=0&id=7b2d0fe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2d0fe6",
  null
  
)

export default component.exports